import React, {useEffect, useState, useRef} from 'react';
import {HashLink as Link} from 'react-router-hash-link';
import { Popover, PopoverBody } from 'reactstrap';
import PropTypes from 'prop-types';
import SvgGauge from "svg-gauge";
import styles from './Gauge.scss';
import tooltipStyles from '../Tooltip/Tooltip.scss';
import { breakPointSmLow } from '../../lib/config';

const defaultOptions = {
  animDuration: 1,
  showValue: true,
  initialValue: 0,
  min: 0,
  max: 10,
  dialStartAngle: 180,
  dialEndAngle: 0,
  label: (value) => (value).toFixed(1),
  color: (value) => value > 7 ? '#69CE97' : value > 3 ? '#FFD234' : '#D1746E',
  viewBox: '0 0 100 60',
};

const LinkWrapper = (props) => {  
  
  let display = props.display;
  
  if(display =='srp' && (window.screen.width <= breakPointSmLow ||window.oth_device == 'phone')){display = 'widget';}
  return (['widget'].includes(display)) ? <div className="d-inline-block" onClick={props.onClick}>{props.children}</div> : <Link to={props.to} className="d-inline-block" onClick={props.onClick}>{props.children}</Link>;
}

function Gauge(props) {
  const gaugeEl = useRef(null);
  const gaugeRef = useRef(null);
  const [propertyUrl, setPropertyUrl] = useState('#liveability');
  const [displayGauge, setDisplayGauge] = useState(false);
  const [gaugeCss, setGaugeCss] = useState(styles.gaugeWrapper);
  const [tooltip, setTooltip] = useState(false);
  const displayThreshold = props.threshold || 0;

  useEffect(() => {
    if (props.value >= displayThreshold) setDisplayGauge(true);
  }, [props.value]);

  useEffect(() => {
    if (props?.url && props.url != '') {
      let url = props.url;
      if (props.display == 'pdp') url = `${url}#liveability`;
      setPropertyUrl(url);
    }
  }, [props.url]);

  useEffect(() => {
    if (displayGauge) {
      if (!gaugeRef.current) {
        const options = { ...defaultOptions, ...props };
        gaugeRef.current = SvgGauge(gaugeEl.current, options);
        gaugeRef.current.setValue(options.initialValue);
      }
      gaugeRef.current.setValue(props.value);
      let gaugeStyles = [styles.gaugeWrapper];
      if (props.boxed) gaugeStyles.push(styles.boxed);
      gaugeStyles.push(styles[props.display]);
      setGaugeCss(gaugeStyles.join(' '));
    }
  }, [displayGauge, props.value]);

  const toggleTooltip = (e) => {
    e.preventDefault();
    setTooltip(!tooltip);
  };

  return (
    displayGauge ?
      <LinkWrapper to={propertyUrl} display={props.display} onClick={props.onClick}>
        <div className={gaugeCss}>
          <div ref={gaugeEl} className={`${styles['gauge-container']} ${styles['two']}`} />
          <Popover
            fade={false}
            trigger={'hover'}
            placement={'bottom-end'}
            isOpen={tooltip}
            target={gaugeEl}
            toggle={toggleTooltip}
            popperClassName={tooltipStyles.popper}
            className={tooltipStyles.alertBox}>
            <PopoverBody>{props.display == 'srp' ? 'High ' : ''}Local Area Liveability Score</PopoverBody>
          </Popover>
        </div>
      </LinkWrapper>
    : null
  );
}

Gauge.defaultProps = {
  boxed: false,
  threshold: 0,
  display: 'widget'
};

Gauge.propTypes = {
  value: PropTypes.number.isRequired,
  url: PropTypes.string, // link to property, hash is added above
  display: PropTypes.oneOf([
    'srp',
    'pdp',
    'widget',
    'similar',
  ]),
  boxed: PropTypes.bool,
  threshold: PropTypes.number // liveability index must be above or equal to threshold to display
};

export default Gauge;
